import OneSignal from "react-onesignal";

let initialized = false;

export const __resetOneSignal = () => {
  initialized = false;
};

const TOTALCASH_HOSTS = [
  "totalcash.net.br",
  "totalcashbr-originacao-dev.byxcapital.com.br",
];

const isTotalcashHost = () => {
  const w = globalThis.window;

  if (!w) return false;

  const host = w.location?.hostname ?? "";
  return TOTALCASH_HOSTS.some((h) => host.includes(h));
};

const getOneSignalAppId = () => {
  if (isTotalcashHost()) {
    return import.meta.env.VITE_ONESIGNAL_APP_ID_TOTALCASH as string;
  }

  return import.meta.env.VITE_ONESIGNAL_APP_ID as string;
};

export const initOneSignal = async () => {
  if (initialized || typeof window === "undefined") return;

  const appId = getOneSignalAppId();

  if (!appId) {
    console.warn("OneSignal AppId não definido");
    return;
  }

  await OneSignal.init({
    appId,
    promptOptions: {
      slidedown: {
        prompts: [
          {
            type: "push",
            autoPrompt: true,
            categories: [],
            delay: {
              pageViews: 1,
              timeDelay: 0,
            },
            text: {
              actionMessage: "Deseja receber nossas notificações?",
              acceptButton: "Sim",
              cancelButton: "Agora não",
            },
          },
        ],
      },
    },
  });

  initialized = true;
};
